export default __webpack_public_path__ + "static/media/desktop.d36d40b0.jpg";